import { render } from "./slot-details-modal.vue?vue&type=template&id=78116e5f&scoped=true&ts=true"
import script from "./slot-details-modal.ts?vue&type=script&lang=ts"
export * from "./slot-details-modal.ts?vue&type=script&lang=ts"

import "./slot-details-modal.scss?vue&type=style&index=0&id=78116e5f&lang=scss&scoped=true"

import exportComponent from "/builds/elichens-avolta-connect/software/avolta-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78116e5f"]])

export default __exports__